// 写一个页面，带一个video标签，和一个div，div中存的是字幕，字幕的显示时间和video的播放时间一致
// 字幕的内容存在json对象中。
// 格式如下：[{'additions': {'event': 'speech', 'speaker': '1'}, 'end_time': 840, 'start_time': 40, 'text': '同价！', 'words': [{'end_time': 120, 'start_time': 40, 'text': '同'}, {'end_time': 840, 'start_time': 160, 'text': '价'}]}]

<template>
    <v-container >
        <header>
            <h2>                    
                粗剪：选段落                                
                <v-btn style="float: right; background-color: rgb(0, 251, 255); color: white;" @click="jump2next">=>细剪</v-btn>
            </h2>  
        </header>
        
        <!-- Add exposure rate chart here -->
        <div id="exposure-chart" style="width:100%; height:180px;" ref="exposureChartDiv" v-if="selectedVideo && selectedVideo.exposure_view_rate && selectedVideo.exposure_view_rate.length > 0"></div>

        <v-row class="mt-2">
            <v-col cols = "12" sm="7">
                <v-row>
                    <v-col cols ="12" :sm="video_cols">
                        <video
                            @loadedmetadata="getVideoRatio"
                            ref="videoPlayer"
                            @timeupdate="updateSubtitle"
                            style="width: 100%; max-width: 800px; max-height: 600px;"
                            controls
                        >
                            <source
                                v-for="(url, index) in video_urls"
                                :key="index"
                                :src="url"
                                type="video/mp4" 
                            >
                            
                        </video>
                        <div style="padding-top: 10px;">
                            <span>北京时间: {{ beijing_time }}</span>
                        </div>  
                        <v-sheet class="d-flex align-center justify-center">
                            <v-row  style="max-width: 300px;" class="d-flex align-center justify-center">
                                <v-col cols="10">
                                    <v-text-field
                                        label="跳转到"
                                        v-model="jump_to_time"
                                        single-line
                                        hide-details
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-btn @click="on_jump_to_time_click">跳转</v-btn>
                                </v-col>
                            </v-row>
                        </v-sheet> 
                        <v-container v-if="Object.keys(speakers).length > 0">
                            <v-row v-for="(words, speaker) in speakers" :key="speaker">
                            <v-col cols="12">
                                <span>说话人{{ speaker }}</span>                                
                                <span class="percentage">&nbsp;&nbsp;占{{ (speaker_percent[speaker]*100).toFixed(1) }}%</span>
                                <div class="gantt-chart">
                                <div
                                    v-for="word in words.slice().reverse()"
                                    :key="word.start_time"
                                    @click="seekTo(word)"
                                    class="gantt-block"
                                    :style="getBlockStyle(word)"
                                ></div>
                                </div>
                            </v-col>
                            </v-row>
                        </v-container>                     
                        <v-btn @click="showInstruction = !showInstruction" class="ma-2">
                            用法说明
                        </v-btn>
                        <v-card v-if="showInstruction" >
                            <v-card-item >                            
                                本页面用于粗剪视频：<br>
                                选内容，调顺序。<br><br>
                                <h5>===用法===</h5><br>
                                点文字（或说话人）跳到视频相应位置<br>
                                框选想要的文字片段<br>
                                然后按 a 添加到剪切区<br>
                                剪切区可通过改序号调段落位置<br><br>

                                空格控制播放暂停<br>
                                ctl+左右键控制前进后退30秒<br>
                            </v-card-item>                        
                        </v-card>


                        
                    </v-col>

                    <v-col cols="12" :sm="clip_cols"  style="overflow-y:auto; text-align: left; ">
                        <v-card>
                            <v-card-item>
                                <v-card-title>剪切区</v-card-title>

                                <v-card-text v-if="to_clip_array.length==0">
                                    <p>剪辑说明：</p>
                                    <p>当前剪切区为空</p>
                                    <p>从右侧文本中划选想要的片段，然后按 a 添加到剪切区</p>
                                </v-card-text>

                                <div v-for="(spans, index) in to_clip_array" :key="index" style="padding-bottom: 10px; position: relative;">
                                    <input type="number" class="order_text" v-model="spanIndexes[index]" @change="moveSpans(index, spanIndexes[index])"/>
                                    <span v-for="(w, index_w) in spans" class='word' :key="index_w" :start_time="w.start_time" :end_time="w.end_time" 
                                        @click="seekTo(w)" 
                                        :class="{
                                            'current': currentWord && w.index_w == currentWord.index_w,
                                            'deleted': w.deleted
                                        }" 
                                        :style="!w.deleted ? getExposureRateStyle(w.start_time) : {}"
                                    >{{ w.text }}</span>
                                    <button @click="removeSpans(index)" class="del_clip_seg">删</button>
                                </div>     
                            </v-card-item>        
                        </v-card>   
                    </v-col>
                </v-row>
            </v-col>

            <v-col cols="12" sm="5" >                
                <v-sheet  style="overflow-y:auto; height: 100vh; text-align: left; ">
                    <div v-for="(p, index_p) in groupedData" class="paragraph" :key="index_p" style="padding-bottom: 10px; text-indent: 2em;">
                        <span v-for="(s, index_s) in p" class="sentence" :key="index_s">
                            <span v-for="(w, index_w) in s" class='word' :key="index_w" :start_time="w.start_time" :end_time="w.end_time" 
                                @click="seekTo(w)" 
                                :class="{'in_slice_history': history_index_w_set.has(w.index_w), 'current': currentWord && w.index_w == currentWord.index_w }" 
                                :style="getExposureRateStyle(w.start_time)"
                            >{{ w.text }}</span>
                            <!-- <span v-for="(w, index_w) in s" class='word' :key="index_w" :start_time="w.start_time" :end_time="w.end_time" @click="seekTo(w.start_time)">{{ w.text }}</span> -->
                        </span>
                    </div>
                </v-sheet>
            </v-col>
            
        </v-row>
     
    </v-container>
    
    
</template>
  
  <script>
    import { ref, computed, onMounted, nextTick, onBeforeUnmount, watch } from 'vue';
    import { useStore } from 'vuex';
    import axios from 'axios';
    import { BASE_URL } from '@/config.js';
    import { useRouter } from 'vue-router';
    // Import Plotly dynamically to avoid blocking
    // import Plotly from 'plotly.js-dist-min';

  export default {

    // name: 'VideoWithWord',
    setup(props, { emit }) {       
        // 从vuex中获得selectedVideo
        const store = useStore()
        
        // Store Plotly module
        const PlotlyModule = ref(null);
        //当前视频字幕素材的完整信息
        const selectedVideo = computed(() => store.state.currentVideo);

        // const video_urls = ref([])
        // const json_data = ref([]);
        const video_urls = computed(() => {
            var urls = [];
            if (!selectedVideo.value) return urls;
            if (!selectedVideo.value.urls) return urls;
            for (let url of selectedVideo.value.urls){
                urls.push(url);
            }
            return urls;
        })
        const json_data = computed(() => {
            if (!selectedVideo.value) return [];
            if (!selectedVideo.value.div_align_content) return [];
            if (selectedVideo.value.div_align_content){
                var reval = JSON.parse(selectedVideo.value.div_align_content)
                for (let i=0; i<reval.length; i++){
                    reval[i].index_i = i;
                }
                return reval;
            }else{
                return []
            }
        });

        const totalTime = computed(() => {
            // 基于word_df，得到最后一个字幕的结束时间
            if (!selectedVideo.value) return 0;
            if (!selectedVideo.value.word_df) return 0;
            if (selectedVideo.value.word_df.length == 0) return 0;
            return selectedVideo.value.word_df[selectedVideo.value.word_df.length-1].end_time;
        })

        //当前字幕素材已产生过哪些切片，基于selectedVideo
        const history_index_w_set = computed(() => {
            var index_w_set = new Set();
            if (!selectedVideo.value) return index_w_set;
            if (!selectedVideo.value.slices) return index_w_set;
            for (let slice of selectedVideo.value.slices){
                // 取出slice.edited_content列表中的每一项中的index_w，放到index_w_set中
                for (let w of slice.edited_content){
                    index_w_set.add(w.index_w);
                }
            }
            return index_w_set;
        });

        // Optimized exposureRateMap computed property
        const exposureRateMap = computed(() => {
            if (!selectedVideo.value || !selectedVideo.value.exposure_view_rate) return {};
            
            const rates = selectedVideo.value.exposure_view_rate;
            if (!rates.length) return {};
            
            // Sort rates by relative time (just to ensure they're in order)
            rates.sort((a, b) => a.相对时间 - b.相对时间);
            
            // Calculate the base offset and interval
            const firstTime = rates[0].相对时间;
            const interval = rates.length > 1 ? Math.round(rates[1].相对时间 - firstTime) : 60;
            
            // Create a fast lookup map
            const map = {
                firstTime,
                interval,
                values: {} // Store rate values by their interval index
            };
            
            // Populate the map
            rates.forEach(rate => {
                // Calculate the index (position) of this measurement
                const index = Math.round((rate.相对时间 - firstTime) / interval);
                map.values[index] = rate.看播率diff;
            });
            
            return map;
        });

        // Optimized getExposureRateStyle function
        const getExposureRateStyle = (startTime) => {
            // Convert startTime from milliseconds to seconds
            const startTimeSeconds = startTime / 1000;
            
            if (!selectedVideo.value || !selectedVideo.value.exposure_view_rate || !exposureRateMap.value.values) 
                return {};
            
            const map = exposureRateMap.value;
            
            // Calculate which interval this time belongs to
            const index = Math.floor((startTimeSeconds - map.firstTime) / map.interval);
            
            // If we have a rate for this interval, use it
            if (index >= 0 && map.values[index] !== undefined) {
                // Get the rate value
                const rate = map.values[index];
                
                // Create gradient color scale:
                // rate <= -0.05 (below -5%): light gray (#cccccc)
                // rate = 0: black (#000000)
                // rate >= 0.05 (above 5%): vivid red (#ff0000)
                
                // Normalize rate to a range between -1 and 1 where:
                // -1 = -5% or lower, 0 = 0%, 1 = 5% or higher
                const normalizedRate = Math.max(-1, Math.min(1, rate / 0.05));
                
                let color;
                
                if (Math.abs(normalizedRate) < 0.01) {
                    // Close to zero - black
                    color = '#000000';
                } else if (normalizedRate < 0) {
                    // Negative rate - interpolate between black and light gray
                    const grayIntensity = Math.floor(204 * Math.abs(normalizedRate)); // 204 is cc in #cccccc
                    color = `rgb(${grayIntensity}, ${grayIntensity}, ${grayIntensity})`;
                } else {
                    // Positive rate - interpolate between black and red
                    const redIntensity = Math.floor(255 * normalizedRate);
                    color = `rgb(${redIntensity}, 0, 0)`;
                }
                
                return {
                    color: color,
                    textShadow: normalizedRate > 0.5 ? '0px 0px 1px rgba(255,255,255,0.3)' : 'none' // Add text shadow for readability on deep red
                };
            }
            
            return {}; // No style for times outside our data range
        }

        //当前视频的说话人
        const speakers = computed(() => {
            if (!selectedVideo.value) return {};
            if (!selectedVideo.value.word_df) return {};
            var speakers_dict = {};
            for (let word of selectedVideo.value.word_df){
                // 如果word.speaker不在speakers中，则添加一个数组到speakers[word.speaker]中
                if (!speakers_dict[word.speaker]){
                    speakers_dict[word.speaker] = [];
                }
                speakers_dict[word.speaker].push(word);
            }
            return speakers_dict;        
        });

        const speaker_percent = computed(() => {
            if (!speakers.value) return {};
            var speaker_percent = {};
            for (let speaker in speakers.value){
                speaker_percent[speaker] = speakers.value[speaker].length / json_data.value.length;
            } 
            return speaker_percent;
        })



        const video_start_time = computed(() => {
            if (!selectedVideo.value) return null;
            if (!selectedVideo.value.shooting_time) return null;
            return new Date(selectedVideo.value.shooting_time).getTime();
        })
        const video_cols = ref(12);
        const clip_cols = ref(12);
        const getVideoRatio = () => {
            if (videoPlayer.value) {
                const ratio = videoPlayer.value.videoWidth / videoPlayer.value.videoHeight;
                console.log('ratio', ratio)
                video_cols.value = ratio>1 ? 12: 7;
                clip_cols.value = ratio>1 ? 12: 5;
                // videoPlayer.value.style.height = videoPlayer.value.videoHeight / videoPlayer.value.videoWidth * videoPlayer.value.offsetWidth + "px";
            }
        }
        const on_jump_to_time_click = () => {
            if (videoPlayer.value){
                var start_ts = new Date(selectedVideo.value.shooting_time);
                start_ts.setSeconds(start_ts.getSeconds()+videoPlayer.value.currentTime);
                var jump_to_ts = new Date(jump_to_time.value);
                var diff = jump_to_ts.getTime() - start_ts.getTime();
                videoPlayer.value.currentTime += diff/1000;
            }
        }

        



        const getBlockStyle = (word) => {
            const duration = totalTime.value;
            const start = (word.start_time / duration) * 100;
            const end = (word.end_time / duration) * 100;
            return {
                position: 'absolute',
                left: `${start}%`,
                width: `${end - start}%`,
                height: '20px',
                backgroundColor: 'blue', // 改变背景颜色来凸显
            };
        }






        //


        onMounted(async () => {
            // Load Plotly dynamically
            import('plotly.js-dist-min').then(module => {
                PlotlyModule.value = module.default || module;
                // Try to create chart if data is already available
                if (selectedVideo.value && selectedVideo.value.exposure_view_rate) {
                    createExposureChart();
                }
            }).catch(e => console.error("Failed to load Plotly", e));

            // 先看看tid是否存在，如果存在，则根据tid获取视频信息
            console.log('tid', tid.value)
            // 如果tid不存在，则从sessionStorage中获取selectedVideo.transcription_id属性
            if (!tid.value && sessionStorage.getItem('currentVideo')){
                tid.value = JSON.parse(sessionStorage.getItem('currentVideo')).transcription_id
            }

            if (tid.value){
                axios.get(`${BASE_URL}video_material/?trans_id=${tid.value}`)
                    .then(response => {
                        // 更新selectedVideoDetail
                        var selectedVideoDetail = response

                        console.log('selectedVideoDetail', selectedVideoDetail)

                        // store.commit('setSelectedVideo', selectedVideoDetail)
                        store.commit('setCurrentVideo', selectedVideoDetail)
                        try{                        
                            sessionStorage.setItem('currentVideo', JSON.stringify(selectedVideoDetail))
                        }catch(e){
                            // console.log('sessionStorage is full')
                            //  从sessionStorage中删除currentVideo
                            sessionStorage.removeItem('currentVideo')
                            console.log(e)
                        }
                        // sessionStorage.setItem('currentVideo', JSON.stringify(selectedVideoDetail))

                        
                        // 填充json_data的内容,selectedVideoDetail.value.segment是一个string, 要转为json对象
                        // json_data.value = JSON.parse(selectedVideoDetail.segment)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }

            // 尝试把sessionStorage中的currentTextSpan取出来，如果有，则更新store中的currentTextSpan

            if (!store.state.currentTextSpan.length && sessionStorage.getItem('currentTextSpan')){
                store.commit('setCurrentTextSpan', JSON.parse(sessionStorage.getItem('currentTextSpan')))
            }
            if (!store.state.currentVideo && sessionStorage.getItem('currentVideo')){
                store.commit('setCurrentVideo', JSON.parse(sessionStorage.getItem('currentVideo')))
            }

            window.addEventListener('keydown', handleKeyDown);

            // 添加监听事件，当视频加载完毕后，设置视频的currentTime
            if (videoPlayer.value) {
                videoPlayer.value.addEventListener('loadedmetadata', () => {
                    if (jtime.value){
                        jump_to_time.value = jtime.value;
                        on_jump_to_time_click();
                    }
                });
            }

            // Create chart after component is mounted
            nextTick(() => {
                if (selectedVideo.value && selectedVideo.value.exposure_view_rate) {
                    createExposureChart();
                }
            });
        })

        onBeforeUnmount(() => {
            window.removeEventListener('keydown', handleKeyDown);

            // Clean up Plotly
            if (exposureChartDiv.value && PlotlyModule.value) {
                PlotlyModule.value.purge(exposureChartDiv.value);
            }
        })

    //     axios.get('src\\assets\\data.json')
    //         .then(response => {
    //             data.value = response.data;
    //         })

       



        // 视频播放器
        const videoPlayer = ref(null);
        const beijing_time = ref(null);
        const currentWord = ref(null);
        const jump_to_time = ref(null);
        // const words = ref(null);
        const seekTo = (word) => {
            if (videoPlayer.value) {
                videoPlayer.value.currentTime = word.start_time / 1000; // 将毫秒转换为秒
                // currentWord.value = word;   

                // console.log('currentTime', videoPlayer.value.currentTime)

                //计算北京时间
                var start_ts = new Date(selectedVideo.value.shooting_time);
                start_ts.setSeconds(start_ts.getSeconds()+word.start_time/1000);
                beijing_time.value = start_ts.toLocaleString('zh-CN', { hour12: false });      
                jump_to_time.value = start_ts.toLocaleString('zh-CN', { hour12: false });           
            }
        }

        const handleKeyDown = (event) => {
            //空格键控制播放暂停
            if (event.keyCode === 32) {
                event.preventDefault();
                if (videoPlayer.value.paused) {
                    videoPlayer.value.play();
                } else {
                    videoPlayer.value.pause();
                }
            }

            //如果是按左键，则向前跳30秒
            if (event.keyCode === 37 && event.ctrlKey) {
                event.preventDefault();
                if (videoPlayer.value.currentTime > 30) {
                    videoPlayer.value.currentTime -= 30;
                } else {
                    videoPlayer.value.currentTime = 0;
                }
            }

            //如果是按右键，则向后跳30秒
            if (event.keyCode === 39 && event.ctrlKey) {
                event.preventDefault();
                if (videoPlayer.value.currentTime < videoPlayer.value.duration - 30) {
                    videoPlayer.value.currentTime += 30;
                } else {
                    videoPlayer.value.currentTime = videoPlayer.value.duration;
                }
            }

            //如果按的是a键，则把选中的字幕加入到剪切区
            if (event.keyCode === 65) {
                // event.preventDefault();
                if (window.getSelection){
                    let from_span = window.getSelection().anchorNode.parentNode;
                    let end_span = window.getSelection().focusNode.parentNode;
                    if (from_span != end_span){
                        let from_word = {'start_time':parseFloat(from_span.getAttribute('start_time')),'end_time':parseFloat(from_span.getAttribute('end_time')),'text':from_span.innerText};
                        let end_word = {'start_time':parseFloat(end_span.getAttribute('start_time')),'end_time':parseFloat(end_span.getAttribute('end_time')),'text':end_span.innerText};
                        
                        if (from_word.start_time > end_word.start_time) {
                            let temp = from_word;
                            from_word = end_word;
                            end_word = temp;
                        }

                        //把from_word, end_word中间的值存到to_clip_array中
                        let new_spans = [];
                        for (let w of json_data.value){
                            // console.log(w.start_time);
                            // console.log(from_word.start_time);
                            // if (w.start_time>1)
                            //     break;
                            if (w.start_time >= from_word.start_time && w.end_time <= end_word.end_time){
                                if (w.start_time == from_word.start_time){
                                    if (w.text == from_word.text){
                                        new_spans.push(w);
                                    }
                                }else if (w.end_time == end_word.end_time){
                                    new_spans.push(w);
                                    if (w.text == end_word.text){
                                        break;
                                    }
                                }
                                else{
                                    new_spans.push(w);
                                }
                            }
                        }
                        to_clip_array.value.push(new_spans);
                    }
                }
         

                
            }
        }

        

        const removeSpans = (index) => {
            to_clip_array.value.splice(index, 1);
        }

        const moveSpans = (oldIndex, newIndex) => {
            //移动剪切区的spans
            // 如果newIndex大于数组长度，则修改newIndex为数组长度
            if (newIndex >= to_clip_array.value.length) {
                newIndex = to_clip_array.value.length;
            }
            // 如果newIndex小于0，则修改newIndex为0
            if (newIndex < 0) {
                newIndex = 0;
            }
            // 把to_clip_array.value中的oldIndex位置的元素移动到newIndex位置
            let temp = to_clip_array.value[oldIndex];
            to_clip_array.value.splice(oldIndex, 1);
            to_clip_array.value.splice(newIndex, 0, temp);
        }

        const groupedData = computed(() => {
            let groups = {};
            json_data.value.forEach(item => {
                
                if (!groups[item.index_p]) groups[item.index_p] = {};
                if (!groups[item.index_p][item.index_s]) groups[item.index_p][item.index_s] = [];
                groups[item.index_p][item.index_s].push(item);
                });
            return groups;
        });
        // const to_clip_array = ref([]);
        const to_clip_array = computed(() => store.state.currentTextSpan);
        const spanIndexes = computed(() => {
            let indexes = [];
            for (let i=0; i<to_clip_array.value.length; i++){
                indexes.push(i);
            }
            return indexes;
        })
           
        const time_last = ref(null);

        const updateSubtitle_old = () => {

            if (videoPlayer.value){
                //计算北京时间
                var start_ts = new Date(selectedVideo.value.shooting_time);
                start_ts.setSeconds(start_ts.getSeconds()+videoPlayer.value.currentTime);
                beijing_time.value = start_ts.toLocaleString('zh-CN', { hour12: false });  

                const currentTime = videoPlayer.value.currentTime * 1000; // 将秒转换为毫秒
                // 打印一下当前时间
                // if (time_last.value){
                //     console.log('diff:', currentTime-time_last.value);
                // }
                time_last.value = currentTime;

                for (let p in groupedData.value) {
                    for (let s in groupedData.value[p]) {
                        for (let w of groupedData.value[p][s]) {
                            if (w.start_time <= currentTime && currentTime < w.end_time) {
                                currentWord.value = w;
                                nextTick(() => {
                                    // 跳到当前播放的位置
                                    let element = document.querySelector(".current");
                                    if(element){
                                        element.scrollIntoView({ behavior: "smooth", block: "center"});
                                    }
                                    // words.value[currentWord.value.index_w].scrollIntoView({ behavior: 'smooth' });
                                });
                                return;
                            }
                        }
                    }
                }

                
            }
            currentWord.value = null;
        }

        const updateSubtitle = () => {

            if (videoPlayer.value){
                if (currentWord.value==null){
                    currentWord.value = json_data.value[0];
                }

                //计算北京时间
                var start_ts = new Date(selectedVideo.value.shooting_time);
                start_ts.setSeconds(start_ts.getSeconds()+videoPlayer.value.currentTime);
                beijing_time.value = start_ts.toLocaleString('zh-CN', { hour12: false });  

                const currentTime = videoPlayer.value.currentTime * 1000; // 将秒转换为毫秒
                // 打印一下当前时间
                // if (time_last.value){
                //     console.log('diff:', currentTime-time_last.value);
                // }
                time_last.value = currentTime;

                // 找到对的currentWord。先用currentTime找到currentWord
                if (currentWord.value.start_time <= currentTime && currentWord.value.end_time >= currentTime){
                    // do nothing 因为当前时间在currentWord的时间范围内  
                }else if (currentTime>currentWord.value.end_time){
                    // 说明当前时间不在currentWord的时间范围内，需要重新找currentWord
                    // 从i位置开始找，在json_data中找到第一个start_time<=currentTime<=end_time的word
                    // console.log('currentWord:', currentWord.value.index_i, 'currentTime:', currentTime, 'json_data length:', json_data.value.length);
                    for (let i = currentWord.value.index_i+1; i<json_data.value.length; i++){
                        if (json_data.value[i].start_time <= currentTime && json_data.value[i].end_time >= currentTime){
                            currentWord.value = json_data.value[i];
                            nextTick(() => {
                                    // 跳到当前播放的位置
                                    let element = document.querySelector(".current");
                                    if(element){
                                        element.scrollIntoView({ behavior: "smooth", block: "center"});
                                    }
                                    // words.value[currentWord.value.index_w].scrollIntoView({ behavior: 'smooth' });
                                });
                            break;
                        }
                        if (json_data.value[i].start_time > currentTime){
                            // 说明已经找到了大于currentTime的word，但是没有找到合适的word
                            break;
                        }
                    }
                }else if (currentTime < currentWord.value.start_time){
                    // 说明当前时间不在currentWord的时间范围内，需要重新找currentWord
                    // 从i位置开始找，在json_data中找到第一个start_time<=currentTime<=end_time的word
                    // console.log('currentWord:', currentWord.value.index_i, 'currentTime:', currentTime, 'json_data length:', json_data.value.length);
                    for (let i = currentWord.value.index_i-1; i>=0; i--){
                        if (json_data.value[i].start_time <= currentTime && json_data.value[i].end_time >= currentTime){
                            currentWord.value = json_data.value[i];
                            nextTick(() => {
                                    // 跳到当前播放的位置
                                    let element = document.querySelector(".current");
                                    if(element){
                                        element.scrollIntoView({ behavior: "smooth", block: "center"});
                                    }
                                    // words.value[currentWord.value.index_w].scrollIntoView({ behavior: 'smooth' });
                                });
                            break;
                        }
                        if (json_data.value[i].end_time < currentTime){
                            // 说明已经找到了小于currentTime的word，但是没有找到合适的word
                            break;
                        }
                    }
                }

 
            }else{
                currentWord.value = null;
            }
        }

        const router = useRouter()  

        const tid = ref(router.currentRoute.value.query.tid ? router.currentRoute.value.query.tid : null)  // 从url中获取的tid参数
        const jtime = ref(router.currentRoute.value.query.jtime ? router.currentRoute.value.query.jtime : null)  // 从url中获取的jtime参数
        const keyword = ref(router.currentRoute.value.query.keyword ? router.currentRoute.value.query.keyword : null)  // 从url中获取的keyword参数

        const jump2next = () => {

            sessionStorage.setItem('currentTextSpan', JSON.stringify(to_clip_array.value));
            //提交to_clip_array.value到vuex中，
            store.commit('setCurrentTextSpan', to_clip_array.value);

            // sessionStorage.setItem('selectedTextSpan', JSON.stringify(to_clip_array.value));

            //然后向父组件发送事件
            // emit('spanSelected', to_clip_array.value)
            router.push('word')

        }
  
    //   onMounted(() => {
    //     videoPlayer.value = this.$refs.videoPlayer;
    //   });

    const showInstruction = ref(false);
      
        // Reference for the chart div
        const exposureChartDiv = ref(null);
        
        // Computed property to prepare exposure rate data for plotting
        const exposureChartData = computed(() => {
            if (!selectedVideo.value || !selectedVideo.value.exposure_view_rate) 
                return { x: [], y: [], xTime: [] };
            
            const rates = selectedVideo.value.exposure_view_rate;
            if (!rates.length) return { x: [], y: [], xTime: [] };
            
            const x = [];  // relative time for plotting
            const y = [];  // exposure rate diff values
            const xTime = []; // actual time strings for tooltip
            
            rates.forEach(rate => {
                x.push(rate.相对时间);
                y.push(rate.看播率diff);
                xTime.push(rate.时间);
            });
            
            return { x, y, xTime };
        });
        
        // Function to create and update the chart
        const createExposureChart = () => {
            if (!exposureChartDiv.value || !exposureChartData.value.x.length || !PlotlyModule.value) return;
            
            const data = [{
                x: exposureChartData.value.x,
                y: exposureChartData.value.y,
                mode: 'lines+markers',
                type: 'scatter',
                line: { shape: 'spline', smoothing: 1.3 },
                marker: {
                    size: 8,
                    color: exposureChartData.value.y.map(val => {
                        if (val > 0.03) return 'red';
                        else if (val < -0.03) return '#888';
                        return 'black';
                    })
                },
                hovertemplate: '<b>时间</b>: %{text}<br><b>看播率变化</b>: %{y:.2%}<extra></extra>',
                text: exposureChartData.value.xTime
            }];
            
            const layout = {
                title: '观众看播率变化趋势',
                xaxis: {
                    title: '视频时间(秒)',
                    showgrid: true,
                    gridcolor: '#eee'
                },
                yaxis: {
                    title: '看播率变化',
                    tickformat: ',.1%',
                    showgrid: true,
                    gridcolor: '#eee',
                    zerolinecolor: '#999'
                },
                margin: { t: 50, l: 60, r: 10, b: 60 },
                hovermode: 'closest',
                plot_bgcolor: 'rgba(240,240,240,0.3)',
                paper_bgcolor: 'rgba(255,255,255,0)'
            };
            
            const config = {
                responsive: true,
                displayModeBar: false
            };
            
            PlotlyModule.value.newPlot(exposureChartDiv.value, data, layout, config);
            
            // Add click event to jump to video position
            exposureChartDiv.value.on('plotly_click', function(data) {
                const pointIndex = data.points[0].pointIndex;
                const clickedTime = exposureChartData.value.x[pointIndex];
                
                // Jump to that time in the video
                if (videoPlayer.value) {
                    videoPlayer.value.currentTime = clickedTime;
                }
            });
        };
        
        // Watch for changes in the exposure rate data and update chart
        watch(() => exposureChartData.value, (newVal, oldVal) => {
            if (newVal.x.length > 0) {
                nextTick(() => {
                    createExposureChart();
                });
            }
        });
        
        // Update chart when video data is available
        watch(() => selectedVideo.value, (newVal, oldVal) => {
            if (newVal && exposureChartDiv.value) {
                nextTick(() => {
                    createExposureChart();
                });
            }
        });
      
      return {
        videoPlayer,
        groupedData,
        seekTo,
        currentWord,
        updateSubtitle,   
        getVideoRatio,
        video_cols,
        clip_cols,     
        to_clip_array,
        removeSpans,
        spanIndexes,
        moveSpans,
        jump2next,
        selectedVideo,
        video_urls,
        history_index_w_set,
        speakers,
        speaker_percent,
        totalTime,
        beijing_time,
        jump_to_time,
        on_jump_to_time_click,
        getBlockStyle,
        showInstruction,
        exposureRateMap,
        getExposureRateStyle,
        exposureChartDiv,
        exposureChartData,
        createExposureChart,
        // words
      };
    },
  };
  </script>

<style scoped>

    .in_slice_history {
        background-color: lightyellow;
    }
    .current {
        background-color: red !important;
        color: white !important
    }



    .del_clip_seg:hover {
        background-color: red;
        color: white;
        border: none;
        padding: 5px 10px;
        border-radius: 30px;
    }
    .del_clip_seg {
        background-color: gray;
        color: black;
        border: none;
        padding: 5px 10px;
        border-radius: 30px;
    } 

    .deleted {
        text-decoration: line-through;
        background-color: lightgray;
        color: gray;
    }

    .order_text {
        margin: 3;
        width: 3ch;
        border: solid 1px #000;
        -moz-appearance: textfield;
    }

    .order_text::-webkit-inner-spin-button,
    .order_text::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    .gantt-chart {
        position: relative;
        width: 100%;
        height: 20px;
        background-color: #eee;
        margin-bottom: 20px;
    }

    .gantt-block {
        position: absolute;
    }

    .percentage {
        color: grey;
    }

</style>
